// ── user-detail-helpers: pure id-guard + label helpers (no JSX) ────────────
// Wave 1 (Users). The user id is a STRING — passed VERBATIM to the typed client,
// NEVER Number()'d. A non-empty len<=200 string is the only client guard a real
// user id can take; a bad/absent id can't be a real record, so the detail/edit
// pages send it back to the list rather than firing a doomed read.

import type { CoachingUserDto } from "../../services/coaching-dtos";

export function isValidUserId(value: string | null | undefined): value is string {
  return typeof value === "string" && value.length > 0 && value.length <= 200;
}

/** Friendly user display name, never a fabricated value. */
export function userDisplayName(user: CoachingUserDto | null | undefined): string {
  if (!user) return "User";
  return user.name || user.email || `User ${user.id}`;
}

/** Find one user in a list by id (the list services are the read source). */
export function findUser(users: CoachingUserDto[], userId: string): CoachingUserDto | null {
  return users.find((user) => user.id === userId) ?? null;
}
